import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getCountriesList = createAsyncThunk(
  'general/getCountriesList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/general/list/countries');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getCountriesList;
